<template>
  <section>
    <b-modal :visible="visible" hide-footer button-size="sm" size="lg" modal-cancel="false" no-close-on-backdrop
      @close="close" id="registration-add">
      <template v-slot:modal-title>Nueva programación</template>
      <section class="container-fluid">
        <!-- Mensaje de carga de datos de estudiantes -->
        <section v-if="dataLoader == false">
          <div class="row">
            <div class="col">
              <p class="text-center">Cargando datos...</p>
            </div>
          </div>
        </section>
        <!-- datos cargados -->
        <template v-else>
          <section v-if="student.id !== null">
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="showConfirm">
                <section class="row">
                  <!-- Estudiante -->
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="type">Estudiante</label>
                      <p v-if="student.person">
                        {{ student.person.last_name }}
                        {{ student.person.first_name }}
                      </p>
                    </div>
                  </div>
                  <!-- Saldo de adelanto -->
                  <div class="col-6" v-if="student.credit > 0">
                    <div class="form-group">
                      <label class="control-label" for="credit">Saldo de adelanto
                      </label>
                      <p :class="messageCredit == '' ? '' : 'mb-0'">
                        <span> Bs. {{ student.credit | currency }}</span>

                        <!-- ver pagos de adelantados -->
                        <button @click="modalListCreditTransaction(student.id)"
                          class="btn btn-sm btn-success float-right" title="Pagos adelantados" type="button">
                          <CIcon size="sm" name="cil-cash" />
                        </button>
                      </p>
                      <small class="text-danger">{{ messageCredit }}</small>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <!-- Último Curso -->
                  <LastScheduledCourse :lastCourse="lastCourse" />
                  <!-- Último tipo de pensión -->
                  <div class="col">
                    <div class="form-group">
                      <label class="control-label" for="type">Último tipo de pensión</label>
                      <p>
                        <span v-if="student.syllabus_tuition">
                          {{ student.syllabus_tuition.name }}
                        </span>
                        <span v-else> - </span>
                      </p>
                    </div>
                  </div>
                </section>

                <section class="row">
                  <!-- Pensum -->
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="syllabus">Pensum</label>
                      <p class="mt-0">
                        {{ student.syllabus.description }} v.
                        {{ student.syllabus.version }}

                        <b-button @click="studentEditSyllabusMod()" variant="warning" title="Cambiar pensum" size="sm">
                          <CIcon size="sm" name="cil-pencil" />
                        </b-button>
                      </p>
                    </div>
                  </div>
                  <!-- year -->
                  <div class="col-3 col-xl-2">
                    <div class="form-group required">
                      <label class="control-label" for="year">Año</label>
                      <b-form-select v-model="registration.year" :options="yearsOptions" id="year" size="sm">
                      </b-form-select>
                    </div>
                  </div>
                  <!-- Periodo -->
                  <div class="col-3 col-xl-4">
                    <div class="form-group required">
                      <ValidationProvider name="period" rules="required" v-slot="{ valid, errors }">
                        <label class="control-label" for="period">Periodo</label>
                        <b-form-select v-model="registration.period" :options="periodOptions" value-field="value"
                          text-field="name" id="period" size="sm">
                          <template #first>
                            <b-form-select-option value="" disabled>-- Seleccione un periodo --</b-form-select-option>
                          </template>
                        </b-form-select>
                        <b-form-invalid-feedback :state="valid">{{
      errors[0]
    }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Tipo de pensíon -->
                  <div class="col-12 col-xl-6">
                    <section class="row" v-if="student.syllabus_id !== null">
                      <StudentSyllabusTuition :syllabus_id="student.syllabus_id" :value="student.syllabus_tuition_id"
                        @syllabus_tuition="setSyllabusTuition"></StudentSyllabusTuition>
                    </section>
                  </div>
                  <div class="col-12 col-xl-6">
                    <template v-if="student.syllabus_id !== null">
                      <StudentCourseOffered :syllabus_id="student.syllabus_id" :period="registration.period"
                        :year="registration.year" :value="student.course_offered_id" :student_id="student.id"
                        @course_offered="setCourseOffered"></StudentCourseOffered>
                    </template>
                  </div>
                </section>

                <!-- se habilita pagar pension siempre y cuanto del tuition price sea mayor 0, y se  -->
                <section class="row" v-if="registration.tuition_price > 0">
                  <!-- Cliente -->
                  <div class="col-12 col-xl-6" v-if="registration.paid == true">
                    <div class="form-group required">
                      <ValidationProvider name="customer_id" rules="required" v-slot="{ valid, errors }">
                        <label class="control-label" for="customer_id">Cliente</label>
                        <b-input-group>
                          <v-select label="name" :options="customersOptions" @search="onSearchCustomers"
                            v-model="registration.customer_id" :reduce="(customer) => customer.id" id="customer_id"
                            style="width: calc(100% - 62px)" placeholder="Buscar Cliente">
                            <template v-slot:no-options="{ search, searching }">
                              <template v-if="searching">
                                No hay resultados para <em>{{ search }}</em>.
                              </template>
                              <em v-else>Buscar Cliente</em>
                            </template>
                            <template v-slot:option="option">
                              <span :class="option.icon"></span>
                              {{ `${option.name}` }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ `${option.name}` }}
                              </div>
                            </template>
                          </v-select>
                          <b-input-group-append>
                            <button @click="customerAddMod" class="btn btn-success btn-sm" type="button">
                              <CIcon size="sm" name="cib-Addthis" />
                            </button>
                            <button @click="customerListMod" class="btn btn-info btn-sm" type="button">
                              <CIcon size="sm" name="cil-list" />
                            </button>
                          </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback :state="valid">{{
      errors[0]
    }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Pagar pensión -->
                  <div class="col-6">
                    <div class="form-group">
                      <label for="paid">Pagar pensión</label>
                      <br />
                      <CSwitch :color="color" v-bind="mode" :checked.sync="registration.paid"
                        :disabled="registration.payment_method_id == 6" id="paid" />
                    </div>
                  </div>
                </section>

                <section class="row" v-if="registration.paid == true">
                  <!-- Multas -->
                  <div class="col">
                    <div class="form-group">
                      <ValidationProvider name="total_fines" :rules="validationSaleTotalFines"
                        v-slot="{ valid, errors }">
                        <label class="control-label" for="total_fines">Multas
                        </label>
                        <currency-input v-model="registration.sale.total_fines" class="form-control form-control-sm"
                          id="total_fines" />
                        <b-form-invalid-feedback :state="valid">{{
      errors[0]
    }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- Total con multas -->
                  <div class="col">
                    <div class="form-group">
                      <label class="control-label" for="total_with_discounts_and_fines">Total con multas
                      </label>
                      <currency-input v-model="registration.sale.total_with_discounts_and_fines
      " class="form-control form-control-sm" id="total_with_discounts_and_fines" readonly />
                    </div>
                  </div>
                </section>

                <section class="row" v-if="registration.paid == true">
                  <!-- Formas de pago -->
                  <div class="col">
                    <PaymentMethodRadioInput v-model="registration.payment_method_id" :name="'payment_method_id'"
                      :rules="'required'" :value="registration.payment_method_id"
                      :disabled="registration.payment_method_id == 6" />
                  </div>
                  <!-- Observación de pago -->
                  <div class="col">
                    <div class="form-group">
                      <ValidationProvider name="observation" rules="max:180" v-slot="{ valid, errors }">
                        <label class="control-label" for="observation">Observación de pago</label>
                        <input type="text" v-model="registration.sale.observation" class="form-control form-control-sm"
                          id="observation" maxlength="180" />
                        <b-form-invalid-feedback :state="valid">{{
      errors[0]
    }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>

                <b-button type="button" size="sm" variant="danger" @click="close">
                  <CIcon size="sm" name="cil-x-circle" /> Cancelar
                </b-button>

                <button type="submit" class="btn btn-success btn-sm float-right" variant="success"
                  :disabled="invalid || addLoader">
                  <span v-if="!addLoader">
                    <CIcon size="sm" name="cil-save" /> Guardar
                  </span>
                  <span v-if="addLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </form>
            </ValidationObserver>
          </section>
        </template>
      </section>
    </b-modal>
    <!-- nuevo customer -->
    <section v-if="modShowCustomerAdd">
      <CustomerAddModal :modShowCustomerAdd="modShowCustomerAdd" @customerAddModal="afterAddCustomer">
      </CustomerAddModal>
    </section>
    <!-- listar customer -->
    <section v-if="modShowCustomerList">
      <CustomerListModal :modShowCustomerList="modShowCustomerList" @customerListModal="afterListCustomer">
      </CustomerListModal>
    </section>
    <!-- editar syllabus -->
    <section v-if="modShowStudentEditSyllabus">
      <StudentEditSyllabusModal :student_id="student.id" :modShowStudentEditSyllabus="modShowStudentEditSyllabus"
        @studentEditSyllabus="afterStudentEditSyllabus">
      </StudentEditSyllabusModal>
    </section>
    <!-- añadir crédito a la transacción -->
    <section v-if="modShowCreditTransactionList">
      <CreditTransactionsListModal :student_id="id_student" :modShowCreditTransactionList="modShowCreditTransactionList"
        @creditTransactionsListModal="afterCreditTransactionsList">
      </CreditTransactionsListModal>
    </section>

    <section v-if="modalShowConfirmProgramming">
      <ConfirmProgrammingModal :lastCourse="lastCourse" :modalShowConfirmProgramming="modalShowConfirmProgramming"
        @confirmProgramming="setConfirmProgramming" />
    </section>
  </section>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
  BModal,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, max, max_value } from "vee-validate/dist/rules";
import Constants from "@/plugins/constants";
//services
import Registrations from "@/plugins/services/registrations";
import Students from "@/plugins/services/students";
import CoursesOffered from "@/plugins/services/courses-offered";
import Customers from "@/plugins/services/customers";
//components
import PaymentMethodRadioInput from "@/entities/payment-methods/PaymentMethodRadioInput";
import CustomerAddModal from "@/entities/customers/CustomerAddModal";
import CustomerListModal from "@/entities/customers/CustomerListModal";
import StudentEditSyllabusModal from "@/entities/students/StudentEditSyllabusModal";
import StudentSyllabusTuition from "@/entities/students/student-syllabus-tuition/student-syllabus-tuition";
import StudentCourseOffered from "@/entities/students/student-course-offered/StudentCourseOffered";
import CreditTransactionsListModal from "@/entities/credit-transactions/CreditTransactionsListModal";
import LastScheduledCourse from "@/entities/registrations/LastScheduledCourse";
import ConfirmProgrammingModal from "@/entities/registrations/ConfirmProgrammingModal";

export default {
  name: "RegistrationAddModal",
  components: {
    BFormInvalidFeedback,
    BFormSelect,
    BFormSelectOption,
    BModal,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    PaymentMethodRadioInput,
    CustomerAddModal,
    CustomerListModal,
    StudentEditSyllabusModal,
    StudentSyllabusTuition,
    StudentCourseOffered,
    CreditTransactionsListModal,
    LastScheduledCourse,
    ConfirmProgrammingModal,
  },
  props: {
    modShowRegistrationAdd: { type: Boolean, required: true },
    student_id: { type: Number, required: true },
  },
  data() {
    return {
      registration: {
        period: null,
        paid: true,
        sale: {
          observation: "",
          total_fines: 0,
          total_with_discounts_and_fines: 0,
        },
        syllabus_tuition_id: null,
        course_offered_id: null,
        customer_id: null,
        tuition_price: 0,
        year: this.$moment().format("YYYY"),
      },
      student: {
        id: null,
        syllabus_id: null,
        syllabus_tuition_id: null,
      },
      mode: { shape: "pill" },
      color: "primary",
      addLoader: false,
      dataLoader: false,
      dataEmit: { modalShow: false, data: null, status: 200 },
      loaderPaid: true,
      periodOptions: Constants.periodOptions2,
      customersOptions: [],
      yearsOptions: [],
      modShowCustomerAdd: false,
      modShowCustomerList: false,
      modShowStudentEditSyllabus: false,
      modShowCreditTransactionList: false,
      modalShowConfirmProgramming: false,
      lastCourse: {
        grade_final_grade: null,
        course_name: null,
        course_id: 0,
        grade_id: 0,
        grade_observations: "NONE",
      },
      registrationSyllabusTuition: {
        syllabus_tuition_id: null,
      }, // ultima programacion del estudiante en el año
      new_course_id: 0,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowRegistrationAdd;
    },
    validationSaleTotalFines() {
      if (
        this.student.credit >= this.registration.tuition_price &&
        this.registration.tuition_price > 0
      ) {
        let max_value = this.student.credit - this.registration.tuition_price;
        return `required|max_value:${max_value}`;
      } else {
        return "required";
      }
    },
    messageCredit() {
      if (
        this.student.credit < this.registration.tuition_price &&
        this.student.credit > 0 &&
        this.registration.tuition_price > 0
      ) {
        return "El saldo de crédito es insuficiente para pagar por adelantado";
      }
      return "";
    },
  },
  mounted() {
    this.yearsOptions = Utils.getYears2(this.userAuth.now);
    this.registration.year = Utils.getYear(this.userAuth.now);
    this.addLoader = false;
    this.dataLoader = false;
    this.getRegistrationSyllabusTuition(this.student_id);
    this.getLastCourse(this.student_id);

  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("max_value", {
      ...max_value,
      message: "Por favor, escribe un valor menor o igual a {max}.",
    });
  },
  watch: {
    "registration.sale.total_fines": function (total_fines) {
      if (total_fines >= 0) {
        this.registration.sale.total_with_discounts_and_fines =
          this.registration.tuition_price + total_fines;
      } else {
        this.registration.sale.total_with_discounts_and_fines =
          this.registration.tuition_price;
      }
    },
  },
  methods: {
    add(print) {
      this.addLoader = true;
      this.registration.created_by = this.userAuth.username;
      this.registration.student_id = this.student_id;
      this.registration.period_name = this.getPeriodName(
        this.registration.period
      );
      this.registration.user_id = this.userAuth.id;
      Registrations.add(this.registration)
        .then((res) => {
          this.addLoader = false;
          if (res.data.success) {
            Utils.setFlash("success", res.data.message);
            if (this.registration.paid == true && print == true) {
              let registrationUrl = `${process.env.MIX_APP_API_ENDPOINT}/registrations/pdf/${res.data.data.id}`;
              Utils.printPdf(registrationUrl);
            }
            this.closeModal(res.data.data);
          } else {
            Utils.setFlash("success", res.data.message);
            this.closeModal();
          }
        })
        .catch((err) => {
          this.addLoader = false;
          if (err.response && err.response.status == 422) {
            this.$refs.form.setErrors(err.response.data.errors);
          }
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", err.response.data.message);
            this.closeModal(null, 404);
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error al crear(500).");
            this.closeModal(null, 500);
          }
        });
    },
    showConfirm() {
      //si el último curso tiene nota de reprobación
      // mostrar una ventana modal si el curso seleccionado es diferente al último curso
      if (
        this.lastCourse.grade_observations == "FAIL" &&
        this.lastCourse.course_id !== this.new_course_id
      ) {
        this.modalShowConfirmProgramming = true;
      } else {
        this.save();
      }
    },
    setConfirmProgramming(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.save();
      }
      this.modalShowConfirmProgramming = response.modalShow;
    },
    save() {
      if (this.registration.paid == true) {
        this.$swal({
          title: "Guardar programación",
          icon: "warning",
          confirmButtonText: "Guardar e imprimir",
          cancelButtonText: "Guardar",
          cancelButtonColor: "#28a745",
          showCancelButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
          allowEnterKey: true,
        }).then((res) => {
          if (res.value) {
            this.add(true);
          } else if (res.dismiss == "cancel") {
            this.add(false);
          } else if (res.dismiss == "esc") {
            this.add(false);
          }
        });
      } else {
        this.add(false);
      }
    },
    closeModal(data = null, status = 200) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("registrationAddModal", this.dataEmit);
    },
    getDataStudent(student_id) {
      Students.getData(student_id)
        .then((res) => {
          this.student = res.data;
          //recuperar el customer
          if (this.student.customer_id !== null) {
            this.registration.customer_id = this.student.customer_id;
            this.getCustomerById(this.student.customer_id);
          }
          this.dataLoader = true;
        })
        .catch((err) => {
          this.dataLoader = true;
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Estudiante no encontrado.");
            this.close();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.close();
          }
        });
    },
    getPeriodName(value) {
      let period = this.periodOptions.find((period) => period.value == value);
      return period.name;
    },
    // search Customers
    onSearchCustomers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.getCustomers(loading, search);
      }
    },
    getCustomers(loading = null, search = null) {
      Customers.selectAll(search)
        .then((res) => {
          this.customersOptions = res.data;
          if (loading != null) {
            loading(false);
          }
        })
        .catch((err) => {
          loading(false);
        });
    },
    getCustomerById(customer_id) {
      Customers.selectAllById(customer_id)
        .then((res) => {
          this.customersOptions = res.data;
          if (this.customersOptions.length == 0) {
            this.registration.customer_id = null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLastCourse(student_id) {
      Registrations.lastCourse(student_id)
        .then((res) => {
          this.lastCourse = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRegistrationSyllabusTuition(student_id) {
      Registrations.getRegistrationSyllabusTuition(student_id)
        .then((res) => {
          if (res.data) {
            this.registrationSyllabusTuition = res.data;
            this.registration.syllabus_tuition_id =
              this.registrationSyllabusTuition.syllabus_tuition_id;
          }
          this.getDataStudent(this.student_id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    customerAddMod() {
      this.modShowCustomerAdd = true;
    },
    afterAddCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.registration.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerAdd = response.modalShow;
    },
    customerListMod() {
      this.modShowCustomerList = true;
    },
    afterListCustomer(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.registration.customer_id = response.data.id;
        this.getCustomerById(response.data.id);
      }
      this.modShowCustomerList = response.modalShow;
    },
    studentEditSyllabusMod() {
      this.modShowStudentEditSyllabus = true;
    },
    afterStudentEditSyllabus(response) {
      if (
        response.data != null ||
        response.status == 404 ||
        response.status == 500
      ) {
        this.registration = {
          period: null,
          course_offered_id: null,
          paid: true,
          syllabus_tuition_id: null,
          sale: {
            observation: "",
            total_fines: 0,
            total_with_discounts_and_fines: 0,
          },
        };
        this.addLoader = false;
        this.dataLoader = false;
        this.getDataStudent(this.student_id);
      }
      this.modShowStudentEditSyllabus = response.modalShow;
    },
    // Setea los datos del tipo de pensión
    setSyllabusTuition(response) {
      let syllabus_tuition = response.data;
      if (syllabus_tuition !== null) {
        this.registration.syllabus_tuition_id = syllabus_tuition.id;
        this.registration.syllabus_tuition_name = syllabus_tuition.main_name;
      }
      // si se selecciono una pension
      if (syllabus_tuition !== null) {
        //verifica si tiene programaciones
        if (this.registrationSyllabusTuition.syllabus_tuition_id == null) {
          // si no tiene programaciones, sacar el primer precio
          this.registration.tuition_price =
            syllabus_tuition.first_tuition_price;
          if (syllabus_tuition.first_tuition_price == 0) {
            this.registration.paid = false;
            this.registration.payment_method_id = 1;
          }
          //realiza una venta
          if (syllabus_tuition.first_tuition_price > 0) {
            this.registration.paid = true;
            this.registration.payment_method_id = 5;
            this.registration.sale.total_with_discounts_and_fines =
              syllabus_tuition.first_tuition_price +
              this.registration.sale.total_fines;
          } else {
            this.registration.sale.total_with_discounts_and_fines =
              syllabus_tuition.first_tuition_price;
          }
        } else {
          //si tiene programaciones sacar el segundo precio
          this.registration.tuition_price =
            syllabus_tuition.second_tuition_price;
          if (syllabus_tuition.second_tuition_price == 0) {
            this.registration.paid = false;
            this.registration.payment_method_id = 1;
          }
          //realiza una venta
          if (syllabus_tuition.second_tuition_price > 0) {
            this.registration.paid = true;
            this.registration.payment_method_id = 5;
            this.registration.sale.total_with_discounts_and_fines =
              syllabus_tuition.second_tuition_price +
              this.registration.sale.total_fines;
          } else {
            this.registration.sale.total_with_discounts_and_fines =
              syllabus_tuition.second_tuition_price;
          }
        }
        // verificar si es estudiante tiene credito, si tiene credito
        // programar con el credito pero no generar factura
        if (
          this.student.credit >= this.registration.tuition_price &&
          this.registration.tuition_price > 0
        ) {
          this.registration.payment_method_id = 6;
        }
      }
    },
    setCourseOffered(response) {
      if (response.data !== null) {
        this.registration.course_offered_id = response.data.id;
        this.registration.course_offered_name = response.data.course_name;
        this.new_course_id = response.data.course_id;
      }
    },
    modalListCreditTransaction(id) {
      this.id_student = id;
      this.modShowCreditTransactionList = true;
    },
    afterCreditTransactionsList(response) {
      // si alguna transacción fue realizada
      if (response.transactionMade) {
        this.registration = {
          period: null,
          course_offered_id: null,
          paid: true,
          syllabus_tuition_id: null,
          sale: {
            observation: "",
            total_fines: 0,
            total_with_discounts_and_fines: 0,
          },
        };
        this.addLoader = false;
        this.dataLoader = false;
        this.getDataStudent(this.student_id);
      }
      this.modShowCreditTransactionList = response.modalShow;
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
